import { motion } from "framer-motion";
import { Reveal, SectionLabel } from "./Reveal";
import { SOLUTIONS } from "@/lib/site";
import { ArrowUpRight } from "lucide-react";

export const Solutions = () => (
  <section id="solutions" data-testid="solutions-section" className="bg-lark-gray py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <div className="max-w-2xl">
        <Reveal>
          <SectionLabel>Our Solutions</SectionLabel>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="mt-5 font-display text-4xl md:text-5xl font-semibold tracking-tight text-lark-ink leading-[1.1]">
            One platform for the way modern teams work
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-5 text-base md:text-lg leading-relaxed text-lark-muted">
            Purpose-built products that connect communication, collaboration, and
            operations across the entire enterprise.
          </p>
        </Reveal>
      </div>

      <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {SOLUTIONS.map((s, i) => {
          const Icon = s.icon;
          return (
            <motion.div
              key={s.title}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.07, ease: [0.22, 1, 0.36, 1] }}
              className="group relative rounded-2xl bg-white border border-gray-100 p-8 shadow-[0_1px_3px_rgba(15,23,42,0.04)] hover:shadow-[0_20px_50px_rgba(22,119,255,0.12)] hover:-translate-y-1 hover:border-lark-blue/20 transition-[transform,box-shadow,border-color] duration-300"
              data-testid={`solution-card-${i}`}
            >
              <div className="grid place-items-center h-14 w-14 rounded-xl bg-lark-light text-lark-blue mb-6 group-hover:bg-lark-blue group-hover:text-white transition-colors duration-300">
                <Icon size={24} />
              </div>
              <h3 className="font-display text-xl font-semibold text-lark-ink">{s.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-lark-muted">{s.desc}</p>
              <ArrowUpRight
                size={20}
                className="absolute top-8 right-8 text-gray-300 group-hover:text-lark-blue group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-[color,transform] duration-300"
              />
            </motion.div>
          );
        })}

        <Reveal delay={0.1} className="lg:col-span-1 sm:col-span-2">
          <a
            href="#contact"
            data-testid="solutions-cta-card"
            className="group flex h-full min-h-[180px] flex-col justify-between rounded-2xl bg-lark-blue p-8 text-white shadow-[0_20px_50px_rgba(22,119,255,0.28)] hover:-translate-y-1 transition-transform duration-300"
          >
            <p className="font-display text-xl font-semibold leading-snug">
              Ready to see Lark in action?
            </p>
            <span className="inline-flex items-center gap-2 text-sm font-semibold">
              Talk to our team
              <ArrowUpRight size={18} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-300" />
            </span>
          </a>
        </Reveal>
      </div>
    </div>
  </section>
);
